module.exports = __webpack_public_path__ + "img/Renewals.5b9be567.svg";